$(document).ready(function () {
    $('.search').select2({
        placeholder: 'Enter a location, town or postcode'
    });

    $('#side-nav a:not([data-toggle])').click(function () {
        if ($(window).width() < 769) {
            toggleNavigation();
        }
    });
});

window.toggleNavigation = function () {
    document.getElementById("app").classList.toggle("offset");
};

window.clearModalFade = function () {
    if ($('.modal-backdrop').length) {
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
    }
};
